import moment from 'moment'

const isJson = (str) => {
  try {
    JSON.parse(str)
  } catch (e) {
    return false
  }
  return true
}

const formatDate = (value, format = 'DD/MM/YYYY') => {
  return moment(value).format(format)
}

export const stringToArrayBuffer = (string) => {
  var binaryString = window.atob(string)
  var len = binaryString.length
  var bytes = new Uint8Array(len)
  for (var i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i)
  }
  return bytes.buffer
}

const format = (
  input,
  opt = { prefix: '', suffix: '', thousands: '.', decimal: ',', precision: 2 }
) => {
  if (!input) return '0'

  if (typeof input === 'number') {
    input = input.toFixed(fixed(opt.precision)) // eslint-disable-line
  }
  const negative = input.indexOf('-') >= 0 ? '-' : ''

  const numbers = onlyNumbers(input)
  const currency = numbersToCurrency(numbers, opt.precision)
  const parts = toStr(currency).split('.')
  let integer = parts[0]
  const decimal = parts[1]
  integer = addThousandSeparator(integer, opt.thousands)
  return (
    opt.prefix +
    negative +
    joinIntegerAndDecimal(integer, decimal, opt.decimal) +
    opt.suffix
  )
}

function joinIntegerAndDecimal (integer, decimal, separator) {
  return decimal ? integer + separator + decimal : integer
}

function addThousandSeparator (integer, separator) {
  return integer.replace(/(\d)(?=(?:\d{3})+\b)/gm, `$1${separator}`)
}

function toStr (value) {
  return value ? value.toString() : ''
}

const numbersToCurrency = (numbers, precision) => {
  const exp = 10 ** precision
  const float = parseFloat(numbers) / exp
  return float.toFixed(fixed(precision))
}

function onlyNumbers (input) {
  return toStr(input).replace(/\D+/g, '') || '0'
}

function fixed (precision) {
  return between(0, precision, 20)
}

// Uncaught RangeError: toFixed() digits argument must be between 0 and 20 at Number.toFixed
function between (min, n, max) {
  return Math.max(min, Math.min(n, max))
}

export default {
  isJson,
  formatDate,
  format,
}
